module.exports = __webpack_public_path__ + "img/seeam-color 1.709f0370.png";